import styled from 'styled-components';

export const HomeContainer = styled.div`
  font-size: 16px;
  text-align: center;
`;
